import { Typography, Color, hexToRgba } from "@/utils/theme";
import styled, { css } from "styled-components";

export interface TextProps {
  $type?: Typography;
  $color?: Color;
  $opacity?: number;
  $isUpperCase?: boolean;
}

const Text = styled.p<TextProps>`
  ${({
    theme,
    $type = "body",
    $color = "black",
    $opacity = 1,
    $isUpperCase = false,
  }) => css`
    font-family: ${theme.typography[$type].fontFamily};
    font-weight: ${theme.typography[$type].fontWeight};
    font-size: ${theme.typography[$type].fontSize};
    line-height: ${theme.typography[$type].lineHeight};
    color: ${hexToRgba(theme.colors[$color], $opacity)};
    text-transform: ${$isUpperCase ? "uppercase" : "initial"};
  `}
`;

export default Text;
